import { apiUrl, exportData, getList } from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';

const baseUrl = apiUrl + '/reports/';
const exportBaseUrl = `${apiUrl}/export/reports/`;

export function getSLAsByCompanies(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}sla/company`, params);
}

export function getSLAsBySku(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}sla/sku`, params);
}

export function getSLAsByWorkflows(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}sla/workflow`, params);
}

export function getWorkflowsByRequesters(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}workflows/requesters`, params);
}

export function getWorkflowsByApprovers(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}workflows/approvers`, params);
}

export function exportSLAsByCompany(params: ApiExportParams): Promise<void> {
  return exportData(`${exportBaseUrl}sla/company`, 'companyName', params);
}

export function exportSLAsBySku(params: ApiExportParams): Promise<void> {
  return exportData(`${exportBaseUrl}sla/sku`, 'gameName', params);
}

export function exportSLAsByWorkflows(params: ApiExportParams): Promise<void> {
  return exportData(`${exportBaseUrl}sla/workflow`, 'name', params);
}

export function exportWorkflowsByRequesters(
  params: ApiExportParams
): Promise<void> {
  return exportData(
    `${exportBaseUrl}workflows/requesters`,
    'keyWorkflowName',
    params
  );
}

export function exportWorkflowsByApprovers(
  params: ApiExportParams
): Promise<void> {
  return exportData(
    `${exportBaseUrl}workflows/approvers`,
    'keyWorkflowName',
    params
  );
}

export function getKeysByPartnerByStatusPivot(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}keys/company/pivot`, params);
}

export function getKeysByPartnerByTagByStatusPivot(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}keys/company/tag/pivot`, params);
}

export function exportKeysByPartnerByStatusPivot(
  params: ApiExportParams
): Promise<void> {
  return exportData(
    `${exportBaseUrl}keys/company/pivot`,
    'companyName',
    params
  );
}
